import { Component, computed, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Language } from '@core/models/language';
import { AuthenticationService } from '@core/services/authentication.service';
import { LanguageService } from '@core/services/language.service';
import { map } from 'rxjs/operators';
import { AppSettingsService } from 'src/app/core/services/app-settings.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
    private authentication = inject(AuthenticationService);
    private router = inject(Router);
    private language = inject(LanguageService);

    readonly isLoggedIn = this.authentication.isLoggedIn;
    readonly username = computed(() => this.authentication.user()?.displayName);
    readonly environment = inject(AppSettingsService).environmentClass;

    @Input()
    hasBackButton = false;

    @Input()
    hasLogo = false;

    isPaneHidden = true;

    readonly actirisLogoUrl$ = this.language.onLangChange.pipe(map((e) => `/assets/images/logo-mail-${e.lang}.png`));

    get currentLanguage(): Language {
        return this.language.language;
    }

    get languages(): string[] {
        return this.language.translate.getLangs();
    }

    get isLoginPage(): boolean {
        return this.router.url.split('?')[0] === '/login';
    }

    changeLanguage(language: string) {
        this.language.translate.use(language);
    }

    public logout(): void {
        void this.router.navigate(['/logout']);
    }

    public back(): void {
        history.back();
    }

    goToActiris() {
        window.location.href = 'https://www.actiris.brussels';
    }
}
